document.addEventListener('DOMContentLoaded', function () {

  const pageWrapper = document.querySelector('.page-wrapper');
  const customTab = document.querySelector('.customTab');

  if (!customTab) {
    // console.log('customTab not found');
    return;
  }


  // ========================================
  // SETTINGS
  // ========================================

  const HEADER_HEIGHT = 94;

  /*
   * Reduces the distance between the target
   * section and the sticky customTab.
   *
   * 0  = full header + tab height
   * 50 = move target 50px higher
   */
  const SECTION_GAP = 60;


  // ========================================
  // STATE
  // ========================================

  let isSticky = false;
  let placeholder = null;

  let stickyDisabled = false;

  let isClickScrolling = false;

  let lastScrollTop = 0;


  /*
   * Original customTab height.
   *
   * Must be measured before customTab
   * becomes fixed.
   */
  let originalTabHeight =
    customTab.offsetHeight;


  // ========================================
  // DETECT SCROLL CONTAINER
  // ========================================

  function isPageWrapperScrolling() {

    if (!pageWrapper) {
      return false;
    }

    const style =
      window.getComputedStyle(pageWrapper);

    const overflowY =
      style.overflowY;

    return (
      (
        overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflowY === 'overlay'
      ) &&
      pageWrapper.scrollHeight >
      pageWrapper.clientHeight
    );
  }


  // ========================================
  // GET CURRENT SCROLL TOP
  // ========================================

  function getScrollTop() {

    if (isPageWrapperScrolling()) {
      return pageWrapper.scrollTop;
    }

    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }


  // ========================================
  // GET SCROLL ELEMENT
  // ========================================

  function getScrollElement() {

    if (isPageWrapperScrolling()) {
      return pageWrapper;
    }

    return window;
  }


  // ========================================
  // NORMAL OFFSET
  // ========================================

  function getNormalOffset() {

    /*
     * When customTab is NOT sticky,
     * only the header needs to be considered.
     */
    return HEADER_HEIGHT;
  }


  // ========================================
  // STICKY OFFSET
  // ========================================

  function getStickyOffset() {

    /*
     * When customTab IS sticky:
     *
     * Header
     * +
     * CustomTab height
     * -
     * SECTION_GAP
     *
     * Example:
     *
     * Header = 94
     * Tab = 64
     * Gap = 50
     *
     * Final = 108px
     */

    return (
      HEADER_HEIGHT +
      originalTabHeight -
      SECTION_GAP
    );
  }


  // ========================================
  // CURRENT OFFSET
  // ========================================

  function getCurrentOffset() {

    if (isSticky) {
      return getStickyOffset();
    }

    return getNormalOffset();
  }


  // ========================================
  // STICKY TRIGGER
  // ========================================

  function getStickyTriggerScrollTop() {

    if (isSticky) {
      return getScrollTop();
    }


    const tabRect =
      customTab.getBoundingClientRect();


    /*
     * Position where customTab reaches
     * the header.
     */

    return (
      getScrollTop() +
      (
        tabRect.top -
        HEADER_HEIGHT
      )
    );
  }


  // ========================================
  // CLICK OFFSET
  // ========================================

  function getClickScrollOffset(
    normalTargetScrollTop
  ) {

    /*
     * --------------------------------------
     * ALREADY STICKY
     * --------------------------------------
     */

    if (isSticky) {

      return getStickyOffset();
    }


    /*
     * --------------------------------------
     * NOT STICKY
     * --------------------------------------
     *
     * Check if the destination will cross
     * the sticky trigger.
     */

    const stickyTrigger =
      getStickyTriggerScrollTop();


    /*
     * If target is beyond the sticky
     * trigger, customTab will be fixed
     * when the target is reached.
     */

    if (
      normalTargetScrollTop >=
      stickyTrigger
    ) {

      return getStickyOffset();
    }


    /*
     * Target is before sticky starts.
     */

    return getNormalOffset();
  }


  // ========================================
  // GET ALL TAB LINKS
  // ========================================

  const tabLinks = Array.from(
    customTab.querySelectorAll(
      '.WhatsinIt a[href^="#"]'
    )
  );


  if (!tabLinks.length) {

    console.log(
      'No WhatsinIt links found'
    );

    return;
  }


  // ========================================
  // CREATE TAB DATA
  // ========================================

  const tabs = tabLinks
    .map(function (link) {

      const href =
        link.getAttribute('href');


      if (!href) {
        return null;
      }


      const sectionId =
        href.replace(/^#/, '');


      const section =
        document.getElementById(
          sectionId
        );


      const tabItem =
        link.closest('.WhatsinIt');


      if (!section || !tabItem) {

        console.log(
          'Section not found:',
          sectionId
        );

        return null;
      }


      return {
        link: link,
        tabItem: tabItem,
        section: section,
        sectionId: sectionId
      };

    })
    .filter(Boolean);


  if (!tabs.length) {

    console.log(
      'No valid tab sections found'
    );

    return;
  }


  // ========================================
  // LAST TAB SECTION
  // ========================================

  const lastTab =
    tabs[tabs.length - 1];


  const lastSection =
    lastTab.section;


  // ========================================
  // ADD STICKY
  // ========================================

  function addSticky() {

    if (
      isSticky ||
      stickyDisabled
    ) {
      return;
    }


    /*
     * IMPORTANT:
     *
     * Get original height BEFORE
     * adding .is-sticky.
     */

    originalTabHeight =
      customTab.offsetHeight;


    placeholder =
      document.createElement('div');


    placeholder.className =
      'customTab-placeholder';


    placeholder.style.width =
      customTab.offsetWidth + 'px';


    placeholder.style.height =
      originalTabHeight + 'px';


    /*
     * Preserve original document space.
     */

    customTab.parentNode.insertBefore(
      placeholder,
      customTab
    );


    customTab.classList.add(
      'is-sticky'
    );


    isSticky = true;


    console.log(
      '✅ .is-sticky ADDED'
    );
  }


  // ========================================
  // REMOVE STICKY
  // ========================================

  function removeSticky() {

    if (!isSticky) {
      return;
    }


    customTab.classList.remove(
      'is-sticky'
    );


    if (placeholder) {

      placeholder.remove();

      placeholder = null;
    }


    isSticky = false;


    console.log(
      '❌ .is-sticky REMOVED'
    );
  }


  // ========================================
  // SET ACTIVE TAB
  // ========================================

  function setActiveTab(tab) {

    tabs.forEach(function (item) {

      item.tabItem.classList.remove(
        'active'
      );

    });


    if (tab) {

      tab.tabItem.classList.add(
        'active'
      );

    }
  }


  // ========================================
  // SCROLL TO SECTION
  // ========================================

  function scrollToSection(tab) {

    if (
      !tab ||
      !tab.section
    ) {
      return;
    }


    const section =
      tab.section;


    const sectionRect =
      section.getBoundingClientRect();


    // ======================================
    // PAGE WRAPPER
    // ======================================

    if (
      isPageWrapperScrolling()
    ) {

      const wrapperRect =
        pageWrapper.getBoundingClientRect();


      /*
       * First calculate where the section
       * would land using header only.
       */

      const normalTargetScrollTop =
        pageWrapper.scrollTop +
        (
          sectionRect.top -
          wrapperRect.top
        ) -
        getNormalOffset();


      /*
       * Determine whether customTab will
       * be sticky at the destination.
       */

      const offset =
        getClickScrollOffset(
          normalTargetScrollTop
        );


      /*
       * Calculate final destination.
       */

      const targetScrollTop =
        pageWrapper.scrollTop +
        (
          sectionRect.top -
          wrapperRect.top
        ) -
        offset;


      isClickScrolling = true;


      /*
       * Activate clicked tab immediately.
       */

      setActiveTab(tab);


      pageWrapper.scrollTo({

        top: Math.max(
          0,
          targetScrollTop
        ),

        behavior: 'smooth'

      });

    }


    // ======================================
    // BODY / WINDOW
    // ======================================

    else {

      /*
       * First calculate target using
       * normal header offset.
       */

      const normalTargetScrollTop =
        window.pageYOffset +
        sectionRect.top -
        getNormalOffset();


      /*
       * Determine destination sticky state.
       */

      const offset =
        getClickScrollOffset(
          normalTargetScrollTop
        );


      /*
       * Final target position.
       */

      const targetScrollTop =
        window.pageYOffset +
        sectionRect.top -
        offset;


      isClickScrolling = true;


      /*
       * Activate clicked tab immediately.
       */

      setActiveTab(tab);


      window.scrollTo({

        top: Math.max(
          0,
          targetScrollTop
        ),

        behavior: 'smooth'

      });
    }


    // ======================================
    // FINISH SMOOTH SCROLL
    // ======================================

    clearTimeout(
      scrollToSection.timer
    );


    scrollToSection.timer =
      setTimeout(function () {

        isClickScrolling = false;


        lastScrollTop =
          getScrollTop();


        /*
         * Recalculate active tab after
         * smooth scrolling finishes.
         */

        updateActiveTab();

      }, 800);
  }


  // ========================================
  // TAB CLICK
  // ========================================

  tabs.forEach(function (tab) {

    tab.link.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        scrollToSection(tab);

      }
    );

  });


  // ========================================
  // UPDATE ACTIVE TAB
  // ========================================

  function updateActiveTab() {

    /*
     * Don't change active tab during
     * smooth scrolling caused by click.
     */

    if (isClickScrolling) {
      return;
    }


    /*
     * IMPORTANT:
     *
     * Manual scrolling uses the CURRENT
     * sticky state.
     */

    const offset =
      getCurrentOffset();


    let currentTab = null;


    // ======================================
    // FIND CURRENT SECTION
    // ======================================

    tabs.forEach(function (tab) {

      const rect =
        tab.section.getBoundingClientRect();


      if (
        rect.top <=
        offset + 10
      ) {

        currentTab = tab;

      }

    });


    // ======================================
    // FIRST TAB DEFAULT
    // ======================================

    /*
     * At the very top, first tab is
     * always active.
     */

    if (
      getScrollTop() <= 5
    ) {

      currentTab =
        tabs[0];

    }


    // ======================================
    // BEFORE FIRST SECTION
    // ======================================

    if (!currentTab) {

      currentTab =
        tabs[0];

    }


    // ======================================
    // APPLY ACTIVE
    // ======================================

    setActiveTab(
      currentTab
    );
  }


  // ========================================
  // HANDLE SCROLL
  // ========================================

  function handleScroll() {

    const currentScrollTop =
      getScrollTop();


    const scrollingDown =
      currentScrollTop >
      lastScrollTop;


    const scrollingUp =
      currentScrollTop <
      lastScrollTop;


    // ======================================
    // LAST SECTION POSITION
    // ======================================

    const sectionRect =
      lastSection.getBoundingClientRect();


    // ======================================
    // SCROLLING DOWN
    // ======================================

    if (scrollingDown) {

      /*
       * ------------------------------------
       * LAST SECTION BOTTOM REACHES
       * WINDOW TOP
       * ------------------------------------
       */

      if (
        !stickyDisabled &&
        sectionRect.bottom <= 0
      ) {

        /*
         * Disable first to prevent
         * immediate sticky re-add.
         */

        stickyDisabled = true;


        removeSticky();


        lastScrollTop =
          currentScrollTop;


        updateActiveTab();


        return;
      }


      /*
       * ------------------------------------
       * NORMAL STICKY LOGIC
       * ------------------------------------
       */

      if (
        !stickyDisabled &&
        !isSticky
      ) {

        const tabRect =
          customTab.getBoundingClientRect();


        if (
          tabRect.top <=
          HEADER_HEIGHT
        ) {

          addSticky();

        }
      }
    }


    // ======================================
    // SCROLLING UP
    // ======================================

    if (scrollingUp) {

      /*
       * ------------------------------------
       * LAST SECTION COMES BACK
       * ------------------------------------
       */

      if (
        stickyDisabled &&
        sectionRect.bottom > 0
      ) {

        stickyDisabled = false;
      }


      /*
       * ------------------------------------
       * ADD STICKY AGAIN
       * ------------------------------------
       */

      if (
        !stickyDisabled &&
        !isSticky
      ) {

        const tabRect =
          customTab.getBoundingClientRect();


        if (
          tabRect.top <=
          HEADER_HEIGHT
        ) {

          addSticky();


          lastScrollTop =
            currentScrollTop;


          updateActiveTab();


          return;
        }
      }


      /*
       * ------------------------------------
       * REMOVE STICKY WHEN ORIGINAL
       * POSITION IS REACHED
       * ------------------------------------
       */

      if (
        isSticky &&
        placeholder
      ) {

        const placeholderRect =
          placeholder.getBoundingClientRect();


        if (
          placeholderRect.top >=
          HEADER_HEIGHT
        ) {

          removeSticky();


          lastScrollTop =
            currentScrollTop;


          updateActiveTab();


          return;
        }
      }
    }


    // ======================================
    // UPDATE ACTIVE TAB
    // ======================================

    updateActiveTab();


    // ======================================
    // UPDATE SCROLL POSITION
    // ======================================

    lastScrollTop =
      currentScrollTop;
  }


  // ========================================
  // ATTACH SCROLL LISTENER
  // ========================================

  const scrollElement =
    getScrollElement();


  if (
    scrollElement === window
  ) {

    window.addEventListener(
      'scroll',
      handleScroll,
      {
        passive: true
      }
    );

  } else {

    pageWrapper.addEventListener(
      'scroll',
      handleScroll,
      {
        passive: true
      }
    );
  }


  // ========================================
  // INITIAL PAGE LOAD
  // ========================================

  /*
   * Store original customTab height.
   */

  originalTabHeight =
    customTab.offsetHeight;


  /*
   * FIRST TAB ACTIVE BY DEFAULT.
   */

  setActiveTab(
    tabs[0]
  );


  /*
   * Store initial scroll position.
   */

  lastScrollTop =
    getScrollTop();


  console.log(
    '✅ First WhatsinIt active by default'
  );


  // ========================================
  // RESIZE
  // ========================================

  window.addEventListener(
    'resize',
    function () {

      /*
       * Recalculate original height
       * only when customTab isn't sticky.
       */

      if (!isSticky) {

        originalTabHeight =
          customTab.offsetHeight;

      } else if (placeholder) {

        originalTabHeight =
          placeholder.offsetHeight;

      }


      updateActiveTab();

      handleScroll();

    }
  );

});

// for ipad issue 
(function () {

  /* ==========================================
     IPAD ONLY DETECTION
     ========================================== */

  function isIPad() {
    const ua = navigator.userAgent || '';
    const platform = navigator.platform || '';

    // Normal iPad
    if (/iPad/i.test(ua)) {
      return true;
    }

    // iPadOS 13+ reports itself as MacIntel
    if (
      platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1
    ) {
      return true;
    }

    return false;
  }


  /* ==========================================
     STOP ON NON-IPAD DEVICES
     ========================================== */

  if (!isIPad()) {
    return;
  }


  /* ==========================================
     ADD / UPDATE SHADOW DOM STYLE
     ========================================== */

  function addStyle(shadowRoot, css, id) {

    if (!shadowRoot) {
      return;
    }

    let style = shadowRoot.querySelector('#' + id);

    if (!style) {
      style = document.createElement('style');
      style.id = id;
      shadowRoot.appendChild(style);
    }

    style.textContent = css;
  }


  /* ==========================================
     REMOVE LOADER / SPINNER FROM BUTTON
     ========================================== */

  function removeButtonLoader(button) {

    if (!button) {
      return;
    }

    const loaders = button.querySelectorAll(`
      .spinner,
      .loading-spinner,
      .loader,
      .loading,
      [class*="spinner"],
      [class*="loader"],
      [class*="loading"],
      [role="progressbar"],
      [aria-label*="loading" i],
      [aria-label*="loader" i],
      [data-loading]
    `);

    loaders.forEach(function (loader) {

      loader.style.setProperty(
        'display',
        'none',
        'important'
      );

      loader.style.setProperty(
        'visibility',
        'hidden',
        'important'
      );

      loader.style.setProperty(
        'opacity',
        '0',
        'important'
      );

    });
  }


  /* ==========================================
     APPLY ALL IPAD STYLES
     ========================================== */

  function applyStyles() {

    const account =
      document.querySelector('shopify-account');

    if (!account || !account.shadowRoot) {
      return;
    }

    const accountRoot = account.shadowRoot;


    /* ==========================================
       ACCOUNT MENU
       ========================================== */

    addStyle(
      accountRoot,
      `
        .account__item-text,
        .account__item {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
        }

        .account__item:hover,
        .account__item:hover .account__item-text {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
        }
      `,
      'custom-account-menu-color'
    );


    /* ==========================================
       LOGIN FORM
       ========================================== */

    const loginForm =
      accountRoot.querySelector(
        'shopify-login-form'
      );

    if (
      !loginForm ||
      !loginForm.shadowRoot
    ) {
      return;
    }

    const loginRoot =
      loginForm.shadowRoot;


    /* ==========================================
       LOGIN CSS
       ========================================== */

    addStyle(
      loginRoot,
      `
        /* ======================================
           EMAIL INPUT
           ====================================== */

        #login-form-email,
        .login-form__email-input {
          color: #000000 !important;
          -webkit-text-fill-color: #000000 !important;
          caret-color: #000000 !important;
          opacity: 1 !important;

          padding-top: 5px !important;
          padding-bottom: 5px !important;
          padding-right: 52px !important;
        }


        /* ======================================
           REMOVE FLOATING EMAIL LABEL
           ====================================== */

        label[for="login-form-email"],
        .login-form__email-label,
        .login-form__label,
        .field__label,
        .input__label {
          display: none !important;
        }


        /* ======================================
           PLACEHOLDER
           ====================================== */

        #login-form-email::placeholder,
        .login-form__email-input::placeholder {
          color: #777777 !important;
          -webkit-text-fill-color: #777777 !important;
          opacity: 1 !important;
        }

        #login-form-email::-webkit-input-placeholder,
        .login-form__email-input::-webkit-input-placeholder {
          color: #777777 !important;
          -webkit-text-fill-color: #777777 !important;
          opacity: 1 !important;
        }


        /* ======================================
           EMAIL FIELD WRAPPER
           ====================================== */

        .custom-ipad-email-wrapper {
          position: relative !important;
          width: 100% !important;
        }


        /* ======================================
           SUBMIT BUTTON
           ====================================== */

        .custom-ipad-email-wrapper
        button[type="submit"] {

          display: flex !important;

          visibility: visible !important;

          opacity: 1 !important;

          pointer-events: auto !important;

          position: absolute !important;

          right: 4px !important;

          top: 50% !important;

          transform: translateY(-50%) !important;

          width: 32px !important;

          height: 32px !important;

          min-width: 32px !important;

          min-height: 32px !important;

          max-width: 32px !important;

          max-height: 32px !important;

          margin: 0 !important;

          padding: 0 !important;

          z-index: 20 !important;

          align-items: center !important;

          justify-content: center !important;

          box-sizing: border-box !important;
        }


        /* ======================================
           HIDE LOADER / SPINNER
           ====================================== */

        .custom-ipad-email-wrapper
        button[type="submit"]
        .spinner,

        .custom-ipad-email-wrapper
        button[type="submit"]
        .loading-spinner,

        .custom-ipad-email-wrapper
        button[type="submit"]
        .loader,

        .custom-ipad-email-wrapper
        button[type="submit"]
        [role="progressbar"],

        .custom-ipad-email-wrapper
        button[type="submit"]
        [aria-label*="loading" i],

        .custom-ipad-email-wrapper
        button[type="submit"]
        [aria-label*="loader" i],

        .custom-ipad-email-wrapper
        button[type="submit"]
        [class*="spinner"],

        .custom-ipad-email-wrapper
        button[type="submit"]
        [class*="loader"],

        .custom-ipad-email-wrapper
        button[type="submit"]
        [class*="loading"],

        .custom-ipad-email-wrapper
        button[type="submit"]
        [data-loading] {

          display: none !important;

          visibility: hidden !important;

          opacity: 0 !important;
        }


        /* ======================================
           KEEP ARROW ICON VISIBLE
           ====================================== */

        .custom-ipad-email-wrapper
        button[type="submit"]
        > svg {

          display: block !important;

          visibility: visible !important;

          opacity: 1 !important;

          width: 18px !important;

          height: 18px !important;
        }


        /* ======================================
           ARROW ICON PATH
           ====================================== */

        .custom-ipad-email-wrapper
        button[type="submit"]
        > svg path {

          visibility: visible !important;

          opacity: 1 !important;
        }
      `,
      'custom-ipad-login-styles'
    );


    /* ==========================================
       FIND EMAIL INPUT
       ========================================== */

    const input =
      loginRoot.querySelector(
        '#login-form-email'
      ) ||
      loginRoot.querySelector(
        '.login-form__email-input'
      );

    if (!input) {
      return;
    }


    /* ==========================================
       DIRECT INPUT STYLES
       ========================================== */

    input.style.setProperty(
      'color',
      '#000000',
      'important'
    );

    input.style.setProperty(
      '-webkit-text-fill-color',
      '#000000',
      'important'
    );

    input.style.setProperty(
      'caret-color',
      '#000000',
      'important'
    );

    input.style.setProperty(
      'opacity',
      '1',
      'important'
    );


    /* ==========================================
       IPAD INPUT PADDING
       ========================================== */

    input.style.setProperty(
      'padding-top',
      '5px',
      'important'
    );

    input.style.setProperty(
      'padding-bottom',
      '5px',
      'important'
    );

    input.style.setProperty(
      'padding-right',
      '52px',
      'important'
    );


    /* ==========================================
       FIND EMAIL FORM
       ========================================== */

    const form =
      input.closest('form');

    if (!form) {
      return;
    }


    /* ==========================================
       FIND SUBMIT BUTTON
       ========================================== */

    let submitButton =
      form.querySelector(
        'button[type="submit"]'
      );

    if (!submitButton) {
      submitButton =
        form.querySelector('button');
    }

    if (!submitButton) {
      return;
    }


    /* ==========================================
       FIND / CREATE EMAIL WRAPPER
       ========================================== */

    let wrapper =
      input.parentElement;


    if (
      !wrapper.contains(
        submitButton
      )
    ) {

      const possibleWrapper =
        submitButton.parentElement;

      if (
        possibleWrapper &&
        possibleWrapper.contains(input)
      ) {
        wrapper =
          possibleWrapper;
      }
    }


    /* ==========================================
       ADD CUSTOM WRAPPER CLASS
       ========================================== */

    wrapper.classList.add(
      'custom-ipad-email-wrapper'
    );


    /* ==========================================
       WRAPPER POSITION
       ========================================== */

    wrapper.style.setProperty(
      'position',
      'relative',
      'important'
    );

    wrapper.style.setProperty(
      'width',
      '100%',
      'important'
    );


    /* ==========================================
       MOVE BUTTON INTO INPUT WRAPPER
       ========================================== */

    if (
      !wrapper.contains(
        submitButton
      )
    ) {

      wrapper.appendChild(
        submitButton
      );
    }


    /* ==========================================
       BUTTON POSITION
       ========================================== */

    submitButton.style.setProperty(
      'display',
      'flex',
      'important'
    );

    submitButton.style.setProperty(
      'visibility',
      'visible',
      'important'
    );

    submitButton.style.setProperty(
      'opacity',
      '1',
      'important'
    );

    submitButton.style.setProperty(
      'pointer-events',
      'auto',
      'important'
    );

    submitButton.style.setProperty(
      'position',
      'absolute',
      'important'
    );

    submitButton.style.setProperty(
      'right',
      '4px',
      'important'
    );

    submitButton.style.setProperty(
      'top',
      '50%',
      'important'
    );

    submitButton.style.setProperty(
      'transform',
      'translateY(-50%)',
      'important'
    );

    submitButton.style.setProperty(
      'width',
      '32px',
      'important'
    );

    submitButton.style.setProperty(
      'height',
      '32px',
      'important'
    );

    submitButton.style.setProperty(
      'min-width',
      '32px',
      'important'
    );

    submitButton.style.setProperty(
      'min-height',
      '32px',
      'important'
    );

    submitButton.style.setProperty(
      'max-width',
      '32px',
      'important'
    );

    submitButton.style.setProperty(
      'max-height',
      '32px',
      'important'
    );

    submitButton.style.setProperty(
      'margin',
      '0',
      'important'
    );

    submitButton.style.setProperty(
      'padding',
      '0',
      'important'
    );

    submitButton.style.setProperty(
      'z-index',
      '20',
      'important'
    );

    submitButton.style.setProperty(
      'align-items',
      'center',
      'important'
    );

    submitButton.style.setProperty(
      'justify-content',
      'center',
      'important'
    );

    submitButton.style.setProperty(
      'box-sizing',
      'border-box',
      'important'
    );


    /* ==========================================
       REMOVE LOADER
       ========================================== */

    removeButtonLoader(
      submitButton
    );


    /* ==========================================
       KEEP ARROW ICON
       ========================================== */

    const arrowIcon =
      submitButton.querySelector(
        ':scope > svg'
      );

    if (arrowIcon) {

      arrowIcon.style.setProperty(
        'display',
        'block',
        'important'
      );

      arrowIcon.style.setProperty(
        'visibility',
        'visible',
        'important'
      );

      arrowIcon.style.setProperty(
        'opacity',
        '1',
        'important'
      );

      arrowIcon.style.setProperty(
        'width',
        '18px',
        'important'
      );

      arrowIcon.style.setProperty(
        'height',
        '18px',
        'important'
      );
    }


    /* ==========================================
       HIDE EMAIL LABEL
       ========================================== */

    const emailLabel =
      loginRoot.querySelector(
        'label[for="login-form-email"]'
      );

    if (emailLabel) {

      emailLabel.style.setProperty(
        'display',
        'none',
        'important'
      );
    }

  }


  /* ==========================================
     INITIAL RUN
     ========================================== */

  applyStyles();


  /* ==========================================
     SHOPIFY DYNAMIC CONTENT
     ========================================== */

  const observer =
    new MutationObserver(function () {
      applyStyles();
    });

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );


  /* ==========================================
     IPAD / SAFARI RETRIES
     ========================================== */

  let count = 0;

  const interval =
    setInterval(function () {

      applyStyles();

      count++;

      if (count >= 30) {
        clearInterval(interval);
      }

    }, 500);

})();


document.addEventListener('DOMContentLoaded', function () {
  const popupElements = document.querySelectorAll('.ImagePopup');

  popupElements.forEach(function (element) {
    element.addEventListener('click', function () {

      const image = element.querySelector('img');
      if (!image) return;

      /* Overlay */
      const overlay = document.createElement('div');

      overlay.style.cssText = `
        position: fixed;
        inset: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        overflow: hidden;
      `;

      /* Image wrapper */
      const imageWrapper = document.createElement('div');

      imageWrapper.style.cssText = `
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        position: relative;
      `;

      /* Popup image */
      const popupImage = document.createElement('img');

      popupImage.src = image.src;
      popupImage.alt = image.alt || '';

      let scale = 1;

      let translateX = 0;
      let translateY = 0;

      let isDragging = false;
      let startX = 0;
      let startY = 0;

      popupImage.style.cssText = `
        max-width: 90vw;
        max-height: 85vh;
        object-fit: contain;
        transform: translate(0px, 0px) scale(1);
        transform-origin: center center;
        user-select: none;
        -webkit-user-drag: none;
        cursor: default;
        transition: transform 0.15s ease;
      `;

      /* Update image */
      function updateImage() {
        popupImage.style.transform =
          `translate(${translateX}px, ${translateY}px) scale(${scale})`;

        if (scale > 1) {
          popupImage.style.cursor = isDragging ? 'grabbing' : 'grab';
        } else {
          popupImage.style.cursor = 'default';
        }
      }

      /* Mouse wheel zoom */
      popupImage.addEventListener('wheel', function (event) {

        event.preventDefault();
        event.stopPropagation();

        if (event.deltaY < 0) {
          // Zoom in
          scale += 0.1;
        } else {
          // Zoom out
          scale -= 0.1;
        }

        // Limit between 1X and 1.5X
        scale = Math.max(1, Math.min(scale, 1.5));

        // Reset position when returning to 1X
        if (scale === 1) {
          translateX = 0;
          translateY = 0;
        }

        updateImage();
      });

      /* Start dragging - ONLY when zoomed */
      popupImage.addEventListener('mousedown', function (event) {

        if (scale <= 1) return;

        event.preventDefault();

        isDragging = true;

        startX = event.clientX - translateX;
        startY = event.clientY - translateY;

        popupImage.style.cursor = 'grabbing';
        popupImage.style.transition = 'none';
      });

      /* Drag */
      document.addEventListener('mousemove', function (event) {

        if (!isDragging || scale <= 1) return;

        translateX = event.clientX - startX;
        translateY = event.clientY - startY;

        updateImage();
      });

      /* Stop dragging */
      document.addEventListener('mouseup', function () {

        if (!isDragging) return;

        isDragging = false;

        popupImage.style.transition = 'transform 0.15s ease';

        updateImage();
      });

      /* Prevent image click from closing popup */
      popupImage.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      imageWrapper.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      /* Close button */
      const closeButton = document.createElement('button');

      closeButton.innerHTML = '&times;';

      closeButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 25px;
        width: 45px;
        height: 45px;
        border: none;
        background: transparent;
        color: #fff;
        font-size: 40px;
        line-height: 40px;
        cursor: pointer;
        z-index: 100001;
        padding: 0;
      `;

      closeButton.addEventListener('click', function (event) {
        event.stopPropagation();
        overlay.remove();
      });

      /* Click outside image closes popup */
      overlay.addEventListener('click', function (event) {

        if (event.target === overlay) {
          overlay.remove();
        }

      });

      /* Build popup */
      imageWrapper.appendChild(popupImage);

      overlay.appendChild(imageWrapper);
      overlay.appendChild(closeButton);

      document.body.appendChild(overlay);
    });
  });
});


// bottom sticky bar sensitivity page

(function () {
  function initBottomStickyBar() {
    const stickyBar = document.querySelector('.bottomSticky');
    const pageWrapper = document.querySelector('.page-wrapper');

    if (!stickyBar) {
      console.warn('Bottom sticky bar not found');
      return;
    }

    const SCROLL_THRESHOLD = 700;

    function checkScroll() {
      const scrollPosition =
        pageWrapper &&
        ['auto', 'scroll', 'overlay'].includes(
          getComputedStyle(pageWrapper).overflowY
        ) &&
        pageWrapper.scrollHeight > pageWrapper.clientHeight
          ? pageWrapper.scrollTop
          : window.scrollY;

      if (scrollPosition > SCROLL_THRESHOLD) {
        stickyBar.classList.add('active');
      } else {
        stickyBar.classList.remove('active');
      }
    }

    window.addEventListener('scroll', checkScroll, {
      passive: true
    });

    if (pageWrapper) {
      pageWrapper.addEventListener('scroll', checkScroll, {
        passive: true
      });
    }

    checkScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initBottomStickyBar
    );
  } else {
    initBottomStickyBar();
  }
})();




// url redirects which are not working from menus
(function () {
  var currentPath = window.location.pathname.replace(/\/+$/, '');

  if (currentPath === '/products') {
    window.location.replace('/collections/all');
  }
})();